import { GraphQLRequestClient } from '@sitecore-jss/sitecore-jss-nextjs/graphql';
import {
  HelpArticleSearchDocument,
  HelpArticleSearchQuery,
} from 'lib/services/queries/HelpArticleSearch.graphql';
import {
  HelpArticleDataDocument,
  HelpArticleDataQuery,
  HelpArticleDataQueryVariables,
} from 'lib/services/queries/HelpArticleData.graphql';
import {
  HelpArticleSearchRelatedDocument,
  HelpArticleSearchRelatedQuery,
} from 'lib/services/queries/HelpArticleSearchRelated.graphql';
import graphqlClientFactory from 'lib/graphql-client-factory';
import { HelpArticleData, TaggedHelpArticle } from 'model/HelpArticle';
import { ItemSearchOperator, ItemSearchPredicateInput } from 'model/Sitecore.graphql';

class HelpArticlesService {
  constructor(private readonly graphQLClient: GraphQLRequestClient) {}

  private createPredicate(t: string): ItemSearchPredicateInput {
    return {
      name: '_path',
      value: t,
      operator: ItemSearchOperator.Contains,
    };
  }

  public async getHelpArticleLayout(articleName: string, siteId: string, language: string) {
    const queryParams = {
      pageSize: 1,
      pageHash: '',
      articleName,
      language,
      siteId,
    };
    const result = await this.graphQLClient.request<HelpArticleSearchQuery>(
      HelpArticleSearchDocument,
      queryParams
    );
    return result.search?.results[0];
  }

  public async getHelpArticleData(
    id: string,
    language: string
  ): Promise<HelpArticleData | undefined> {
    const queryParams: HelpArticleDataQueryVariables = { path: id, language };
    const result = await this.graphQLClient.request<HelpArticleDataQuery>(
      HelpArticleDataDocument,
      queryParams
    );

    return result.item as HelpArticleData;
  }

  public async getTaggedHelpArticles(
    language: string,
    siteId: string,
    currentArticleId: string,
    predicates: Array<string>
  ): Promise<TaggedHelpArticle[] | undefined> {
    const queryParams = {
      siteId,
      language,
      currentArticleId,
      tags: predicates.map(this.createPredicate) ?? [],
      pageSize: 8,
    };
    const result = await this.graphQLClient.request<HelpArticleSearchRelatedQuery>(
      HelpArticleSearchRelatedDocument,
      queryParams
    );
    return (result?.search?.results as TaggedHelpArticle[]) ?? [];
  }
}

export const helpArticlesService = new HelpArticlesService(graphqlClientFactory());
